<template>
    <div class="card height-100">
      <div class="card-content">
        <p class="has-text-weight-bold">{{ $t('gestionAffectation.informationCommande.title',
          { codeCommande: commande.code, annonceur: getAnnonceur }) }}</p>
        <p class="has-text-default is-size-7 mgt-10px">
          {{ $t('gestionAffectation.informationCommande.theme', { theme: commande.theme }) }}</p>
        <b-field class="mgt-20px">
          <router-link-blank
            :to="{ name: 'c.bodac.commandes', params: { id: commande.id } }"
            :message="$t('gestionAffectation.informationCommande.plusdinfo')"
            classComposant="is-underline lien">
          </router-link-blank>
          <router-link-blank class="mgl-10px"
            :to="{ name: 'c.bodac.commandes', params: { id: commande.id } }" icon="open-in-new"
            sizeIcon="is-small"
            classComposant="is-underline lien">
          </router-link-blank>
        </b-field>
      </div>
    </div>
</template>

<script>
import RouterLinkBlank from '@/components/general/routerLinkBlank';

export default {
  name: 'informationCommande',
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getAnnonceur() {
      const annonceur = this.commande.intervenants
        .find((intervenant) => { return intervenant.annonceur; });
      return annonceur ? annonceur.nomCommercial : '';
    },
  },
  components: {
    RouterLinkBlank,
  },
};
</script>

<style scoped>

</style>
